export default `Este importador aplica os dados da planilha com validações mais flexíveis.
A conferência do layout e dos preenchimentos é essencial para garantir a qualidade das informações.
As validações completas ocorrem nas operações via tela.`
